import { Slider } from 'antd'
import moment from 'moment'

import React, { FC, useEffect, useMemo, useRef } from 'react'
import { useAudio } from 'react-use'
import { BtnAnch } from '../global'

const MAudio: FC<{
 loading?: boolean
 duration?: number | null
 src: string
 autoPlay?: boolean
}> = ({ src, duration: Mduration, loading, autoPlay }) => {
 const [audio, state, controls] = useAudio({ src })
 const { duration, time } = state
 const autoPlayedRef = useRef(false)

 // The recording is fetched as a blob after the user clicks Play, so `src`
 // only becomes available once loading finishes - auto-play then so the
 // first click actually starts audio instead of just revealing the button.
 useEffect(() => {
  if (autoPlay && !loading && src && !autoPlayedRef.current) {
   autoPlayedRef.current = true
   stopPlayingAllAudios()
   controls.play()
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [autoPlay, loading, src])
 // const { curTime, curTimeFormat, duration, durationFormat, isPlaying, setClickedTime, togglePlay, isLoading } = useAudio(src)

 const recorderDuration = useMemo(
  () =>
   moment
    .utc(
     moment
      .duration(Mduration ?? state.duration ?? 0, 'second')
      .asMilliseconds(),
    )
    .format('mm:ss'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [Mduration, src, state.duration],
 )

 //  const tim = moment.duration(time ?? 0, 'minutes').humanize()

 return (
  <div className="m-audio">
   {/* <pre>{JSON.stringify(state, null, 2)}</pre> */}
   {audio}
   {loading ? (
    <BtnAnch className="audio-control">
     <i className="fas fa-spin fa-spinner" />
    </BtnAnch>
   ) : (
    <BtnAnch
     onClick={() => {
      if (state.playing) {
       controls.pause()
      } else {
       stopPlayingAllAudios()
       controls.play()
      }
     }}
     className="audio-control"
    >
     {state.playing ? (
      <i className="fas fa-pause" />
     ) : (
      <i className="fas fa-play" />
     )}
    </BtnAnch>
   )}

   <div className="time-blk">
    {/* {time} */}
    {state.playing || time > 0
     ? moment
        .utc(moment.duration(time, 'second').asMilliseconds())
        .format('mm:ss')
     : recorderDuration}
   </div>
   <span className="audio-range">
    <Slider
     className="w-100"
     onChange={controls.seek}
     value={time}
     min={0}
     max={Mduration ?? duration}
    />
   </span>
  </div>
 )
}

export default MAudio

export const stopPlayingAllAudios = () => {
 const audios = document.getElementsByTagName('audio')
 if (audios) {
  for (let i = 0, len = audios.length; i < len; i++) {
   if (!audios[i].paused) {
    audios[i].pause()
    audios[i].currentTime = 0
   }
  }
 }
}
